module.exports = __webpack_public_path__ + "img/penta5classic_icon.6cd51527.png";